 
import { Stand } from "./Stand";
import { Projet } from "./Projet";
import { Contact } from './Contact';
import { Pjoint } from './Pjoint';
import { Prospect } from './Prospect';

export class Client {
    idClient: number;
    prospectId: Prospect;
    standList:string;
    superficie: string;
    solde: number;
    type: string;
    numeroFiche:string
    observation: string;
    
    finance: boolean;
    contact: Contact;
    pjointContrat: Pjoint;
    projetId:Projet;
    exposantPstring:string;
    concretiserPar:string;
    raisonSocial:string;
    logisticSend:boolean;
    dateEdit:Date;
    clientsConstructeurs:string
    prestatairesClientList:any;

    packageSponsor:string;
 

}
export class Idencrypt {
    id: number;
    crypt: string;
}